import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock } from "lucide-react";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/courses").then(({data}) => setCourses(data)).finally(()=>setLoading(false));
  }, []);

  return (
    <div data-testid="courses-page" className="grid-bg min-h-[85vh]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <span className="sticker">CATÁLOGO</span>
        <h1 className="font-bebas text-6xl md:text-8xl mt-6 tracking-tighter">
          OS <span className="text-[#CCFF00]">CURSOS</span>
        </h1>
        <p className="text-white/60 mt-4 font-manrope max-w-2xl">
          Escolha teu caminho. Do básico ao avançado, em português direto.
        </p>

        {loading ? (
          <div className="mt-16 text-white/40 font-manrope">Carregando...</div>
        ) : (
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.map((c, i) => (
              <Link
                key={c.id}
                to={`/cursos/${c.id}`}
                data-testid={`course-card-${c.id}`}
                className="brutal-card block group"
                style={{borderColor: c.color || '#F5F5F5'}}
              >
                <div className="flex items-start justify-between">
                  <span className="font-bebas text-xs tracking-widest text-white/50">{c.level}</span>
                  <span className="font-bebas text-xs tracking-widest text-white/50">{c.duration}</span>
                </div>
                <div className="mt-4 font-bebas text-4xl tracking-tighter leading-none" style={{color: c.color}}>
                  {c.emoji_tag}
                </div>
                <h3 className="mt-6 font-bebas text-3xl leading-none tracking-tight">{c.title}</h3>
                <p className="mt-3 text-white/60 font-manrope text-sm">{c.tagline}</p>
                <div className="mt-6 flex items-center justify-between">
                  <span className="font-manrope text-sm text-white/40">{c.lessons?.length || 0} aulas</span>
                  <span className="font-bebas text-lg text-[#CCFF00] group-hover:translate-x-1 transition-transform">COMEÇAR →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
